import { MFA_SETTINGS_ACTIVE } from '../../constants/ui.labels'
import { Heading, Text } from '@talkdesk/cobalt-react-typography'
import { useTheme } from '@talkdesk/cobalt-react-theme-provider'
import Tag from '@talkdesk/cobalt-react-tag'
import Flex from '@talkdesk/cobalt-react-flex'
import IconProvider from '@talkdesk/cobalt-react-icon'

const MechanismOption = ({
  icon,
  name,
  description,
  isActive,
  activeColor,
  defaultColor,
}) => {
  const theme = useTheme()
  const defaultColorValue = defaultColor || theme.gray500

  return (
    <Flex gap='4' alignY='center' alignX='space-between' padding='5'>
      <IconProvider
        name={icon}
        size='medium'
        color={isActive ? activeColor : defaultColorValue}
      />
      <Flex direction='column' gap='1'>
        <Heading level='3' asLevel='5'>
          <Flex gap='2'>
            {name}
            {isActive && (
              <Tag color='green' size='small'>
                {MFA_SETTINGS_ACTIVE}
              </Tag>
            )}
          </Flex>
        </Heading>
        <Text inline>
          <em>{description}</em>
        </Text>
      </Flex>
    </Flex>
  )
}

export default MechanismOption
